/*
 * Home Google reviews carousel (sections/home-google-reviews.liquid).
 * Progressive enhancement: the reviews are plain HTML in a scroll-snap list; this file adds
 * prev/next, page dots and optional auto-rotation. Follows the WAI-ARIA carousel pattern:
 *  - auto-rotation is opt-out (pause button) and stops for good after any user interaction
 *  - never rotates with prefers-reduced-motion, while hovered / focused, off-screen or in a hidden tab
 *  - aria-live is "off" while rotating and "polite" once the user drives it
 */
(function () {
  'use strict';
  if (window.__aiooGoogleReviews) return;
  window.__aiooGoogleReviews = true;

  function init(root) {
    var track = root.querySelector('[data-gr-track]');
    var controls = root.querySelector('[data-gr-controls]');
    if (!track || !controls) return;
    var slides = Array.prototype.slice.call(track.children);
    var prevBtn = root.querySelector('[data-gr-prev]');
    var nextBtn = root.querySelector('[data-gr-next]');
    var dotsWrap = root.querySelector('[data-gr-dots]');
    var toggle = root.querySelector('[data-gr-toggle]');
    var counter = root.querySelector('[data-gr-counter]');
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var wantsAutoplay = root.getAttribute('data-autoplay') === '1' && !!toggle;

    var perView = 1;
    var pages = 1;
    var page = 0;
    var dots = [];
    var timer = null;
    var userStopped = false;
    var hovered = false;
    var focused = false;
    var inView = false;
    var ticking = false;

    function measure() {
      var first = slides[0];
      if (!first) return;
      var slideW = first.getBoundingClientRect().width;
      var viewW = track.clientWidth;
      perView = Math.max(1, Math.round(viewW / Math.max(slideW, 1)));
      pages = Math.max(1, Math.ceil(slides.length / perView));
    }

    function buildDots() {
      dotsWrap.textContent = '';
      dots = [];
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aioo-greviews__dot';
        b.setAttribute('aria-label', (dotsWrap.getAttribute('data-page-label') || '').replace('%n%', i + 1) || String(i + 1));
        b.setAttribute('data-gr-page', String(i));
        b.innerHTML = '<span aria-hidden="true"></span>';
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function currentPage() {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 3) return pages - 1;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return Math.min(pages - 1, Math.floor(best / perView));
    }

    function paint() {
      page = currentPage();
      for (var i = 0; i < dots.length; i++) {
        if (i === page) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
      if (counter) counter.textContent = (page + 1) + ' / ' + pages;
    }

    function goTo(p, instant) {
      var target = slides[Math.min(slides.length - 1, p * perView)];
      if (!target) return;
      var left = target.offsetLeft - slides[0].offsetLeft;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: instant || reduce.matches ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    function step(dir) {
      var p = currentPage() + dir;
      if (p >= pages) p = 0;
      if (p < 0) p = pages - 1;
      goTo(p);
    }

    function canRun() {
      return wantsAutoplay && !userStopped && !reduce.matches && !hovered && !focused && inView && !document.hidden && pages > 1;
    }

    function schedule() {
      clearTimeout(timer);
      timer = null;
      track.setAttribute('aria-live', canRun() ? 'off' : 'polite');
      if (!canRun()) return;
      timer = setTimeout(function () {
        step(1);
        schedule();
      }, interval);
    }

    function setToggleState() {
      if (!toggle) return;
      var playing = wantsAutoplay && !userStopped;
      toggle.setAttribute('aria-label', toggle.getAttribute(playing ? 'data-label-pause' : 'data-label-play'));
      toggle.classList.toggle('is-paused', !playing);
    }

    function stopForGood() {
      if (userStopped) return;
      userStopped = true;
      setToggleState();
      schedule();
    }

    function layout() {
      measure();
      buildDots();
      controls.hidden = pages <= 1;
      root.classList.toggle('is-static', pages <= 1);
      paint();
      schedule();
    }

    // Controls
    prevBtn.addEventListener('click', function () { stopForGood(); step(-1); });
    nextBtn.addEventListener('click', function () { stopForGood(); step(1); });
    dotsWrap.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-gr-page]') : null;
      if (!b) return;
      stopForGood();
      goTo(parseInt(b.getAttribute('data-gr-page'), 10) || 0);
    });
    if (toggle) {
      toggle.addEventListener('click', function () {
        userStopped = !userStopped;
        setToggleState();
        schedule();
      });
    }
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stopForGood(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); stopForGood(); step(-1); }
    });

    // Manual swipe / wheel = the user takes over
    ['pointerdown', 'touchstart'].forEach(function (evt) {
      track.addEventListener(evt, stopForGood, { passive: true });
    });
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stopForGood();
    }, { passive: true });

    // Pause conditions
    root.addEventListener('mouseenter', function () { hovered = true; schedule(); });
    root.addEventListener('mouseleave', function () { hovered = false; schedule(); });
    root.addEventListener('focusin', function () { focused = true; schedule(); });
    root.addEventListener('focusout', function () { focused = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);
    if (reduce.addEventListener) reduce.addEventListener('change', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.35 }).observe(root);
    } else {
      inView = true;
    }

    // Keep dots in sync with scrolling (rAF throttled)
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    // Re-measure on resize
    var resizeTimer;
    var onResize = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 120);
    };
    if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(track);
    else window.addEventListener('resize', onResize);

    setToggleState();
    layout();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-aioo-greviews]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
